import * as TYPES from './types'

/**
 * Default UI State
 */
export const defaultState:TYPES.UIState = {
  ui_sidebar_open: false,
}

// define initial state object
const initialState: TYPES.UIState = {
  ui_sidebar_open: defaultState.ui_sidebar_open,
}

// define ui reducer
export function uiReducer (
  state = initialState,
  action: TYPES.UIActionTypes
): TYPES.UIState {
  switch (action.type) {
    case TYPES.UI_SET_SIDEBAR_STATE: {
      return {
        ...state,
        ...{ ui_sidebar_open: action.sideBarState }
      }
    }
    default:
      return state
  }
}
